import React, { useState, useEffect, useRef } from "react";
import { useSelected } from "../contexts/SelectedContext";
import "../styles/filter.css";
import { useTheme } from "../contexts/NewThemeContext";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { storage } from "../Services/storage.service";
import { storageKeys } from "../Constants/storage.key";

export const Filters = (props) => {
  const { themeColors } = useTheme();
  const Icon = props.icon;
  const isMulti = props.isMulti === true;
  const isLoading = props.isLoading || false;
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  // const isDark = useTheme();
  const dispatch = useDispatch();

  const { pageTitle } = useSelector(
    (rootReducer) => rootReducer.layoutDataReducer
  );

  const { selectedValues, setSelectedValues, toggleOption } = useSelected();

  const getValue = (opt) => {
    // Se for string "TODOS", retorna 0
    if (opt === "TODOS") return 0;
    if (typeof opt === "string") {
      const speedEvent = getSpeedEventTypeValue(opt);
      const visitEvent = getVisitEventTypeValue(opt);
      return speedEvent ?? visitEvent ?? opt;
    }
    if (typeof opt === "number") return opt;

    // 👈 Sempre retorna o ID do objeto, não a posição
    if (opt?.vehicleId !== undefined) return opt.vehicleId;
    if (opt?.groupVehicleId !== undefined) return opt.groupVehicleId;
    if (opt?.vehicleGroupId !== undefined) return opt.vehicleGroupId;
    if (opt?.driverId !== undefined) return opt.driverId;
    if (opt?.userDriverId !== undefined) return opt.userDriverId;
    if (opt?.maintenanceItemId !== undefined) return opt.maintenanceItemId;
    if (opt?.statusId !== undefined) return opt.statusId;
    if (opt?.slug) return opt.slug;
    if (opt?.startDate) return opt.startDate;
    if (opt?.endDate) return opt.endDate;

    return "";
  };

  const getCurrentSelectedByMenu = () => {
    const baseSelected = selectedValues[props.id] || [];
  
    // Se não é o filtro de gráficos, retorna normal
    if (props.id !== "grafico") {
      return baseSelected;
    }
  
    // ✅ FILTRAR: manter apenas os menuIds que estão em allowedMenuIds
    const filteredSelected = baseSelected.filter(selectedValue => {
      return props.options.some(opt =>
        getValue(opt) === selectedValue && opt.menuId
      );
    });
  
    // ✅ Se ficou vazio, retorna vazio mesmo
    return filteredSelected;
  };
  

  const currentSelected = getCurrentSelectedByMenu();

  // --- Funções auxiliares ---
  

  const getSpeedEventTypeValue = (opt) => {
    switch (opt) {
      case "Somente velocidade da empresa":
        return 1;
      case "Acima da velocidade da via - infração média":
        return 2;
      case "Acima da velocidade da via - infração grave":
        return 3;
      case "Acima da velocidade da via - infração gravíssima":
        return 4;
      case "Acima da velocidade da via - infração (todos)":
        return 5;
      case "Todos":
        return 6;
      default:
        return null;
    }
  };

  const getVisitEventTypeValue = (opt) => {
    switch (opt) {
      case "Visita":
        return 1;
      case "Parada":
        return 2;
      case "Visita ou parada":
        return 3;
      default:
        return null;
    }
  };

  const getLabel = (opt) => {
    if (typeof opt === "string") {
      if (opt === "TODOS" && pageTitle === "Vincular usuários aos grupos" || pageTitle === "Agendamento de itens") {
        return "Selecione o filtro";
      }
      return opt;
    }
    if (typeof opt === "number") return opt.toString();

    return (
      opt?.plate ||
      opt?.groupVehicleName ||
      opt?.chart ||
      opt?.periodo ||
      opt?.vehicleGroupName ||
      opt?.name ||
      opt?.driverName ||
      opt?.userDriverName ||
      opt.maintenanceItemName ||
      opt?.statusName ||
      "Selecione"
    );
  };

  const getOptionsWithTodos = () => {
    const safeOptions = Array.isArray(props.options) ? props.options : [];

    const filterIds = ["veiculos", "grupos", "motoristas", "gruposModal"];

    const pageTitles = [
      "gridJourneyWork",
      "gridSpeedControl",
      "gridVisitAmount",
      "gridPeriodVisits",
      "gridProtocols",
      "Radar",
      "Veículo mais próximo",
      "ControlPoint",
      "EletronicFences",
      "RiskArea",
      "globalHeader",
      "VehiclesConfiguration",
      "maintenances_pendings",
      "maintenances_scheduling",
      "maintenances_shipping"
    ];

    const shouldAddTodosBase =
      filterIds.includes(props.id) ||
      (props.id === "veiculosGroups" && pageTitles.includes(props.pageTitle));

    const shouldAddTodos =
      shouldAddTodosBase &&
      !(
        props.id === "veiculosGroups" &&
        props.pageTitle === "gridJourneyWork"
      );

    let options = shouldAddTodos ? ["TODOS", ...safeOptions] : safeOptions;

    if (
      props.id === "veiculosGroups" &&
      props.pageTitle === "gridSpeedControl" &&
      options.length > 0 &&
      (options[0] !== "TODOS")
    ) {
      options[0] = "TODOS";
    }

    return options;
  };


  const optionsWithTodos = getOptionsWithTodos();


  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const summaryLabel = () => {
    if (!isMulti) return props.hasSubTitle ? props.subTitle : "";
    if (currentSelected.length === 0) return "Selecionar";
    if (currentSelected.length === 1) return "1 selecionado";
    return `${currentSelected.length} selecionados`;
  };

  const cleanedRef = useRef(false);

  // Verifica se este filtro específico tem dados salvos no cookie
  const hasFilterInCookie = () => {
    const userSessionData = storage.get(storageKeys.settings);
    const userId = userSessionData?.userId || 'anonymous';
    const saved = Cookies.get(`selectedFilters_${userId}`);
    if (!saved) return false;
    
    try {
      const parsed = JSON.parse(saved);
      return parsed[props.id] && parsed[props.id].length > 0;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    // Só executa se este filtro NÃO tem dados salvos no cookie
    if (hasFilterInCookie()) return;
    
    const screensToClean = ["MIRUS VIEW", "Veículo mais próximo"];

    if (
      pageTitle &&
      !cleanedRef.current &&
      (
      props.id === "veiculos" ||
      screensToClean.includes(pageTitle) ||
      !isMulti ||
      optionsWithTodos?.length > 0 ||
      currentSelected.length === 0
      )
    ) {
      const firstValue = "TODOS";
      setSelectedValues((prev) => ({
        ...prev,
        [props.id]: [firstValue],
      }));

      cleanedRef.current = true;
    }

    if (pageTitle && !screensToClean.includes(pageTitle)) {
      cleanedRef.current = false;
    }
  }, [pageTitle, props.id, setSelectedValues]);

  useEffect(() => {
    // Só executa se este filtro NÃO tem dados salvos no cookie
    if (hasFilterInCookie()) return;
    
    const screensToClean = ["MIRUS VIEW", "Veículo mais próximo"];
    if (
      props.id === "veiculos" &&
      !isMulti &&
      optionsWithTodos?.length > 0 &&
      currentSelected.length === 0 &&
      pageTitle &&
      screensToClean.includes(pageTitle)
    ) {
      const firstValue = "TODOS";
      setSelectedValues((prev) => ({
        ...prev,
        [props.id]: [firstValue],
      }));
    }
  }, [
    isMulti,
    optionsWithTodos,
    props.id,
    currentSelected,
    setSelectedValues,
    pageTitle,
  ]);

  useEffect(() => {
    // Só executa se este filtro NÃO tem dados salvos no cookie
    if (hasFilterInCookie()) return;
    
    setSelectedValues((prev) => ({
      ...prev,
      [props.id]: [getValue(optionsWithTodos[0])],
    }));
  }, [pageTitle]);

  // --- Manipula a mudança de seleção ---
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    setSelectedValues((prev) => ({
      ...prev,
      [props.id]: [selectedValue],
    }));

    if (typeof props.onManualSelection === "function") {
      props.onManualSelection();
    }

    if (typeof props.onChange === "function") {
      props.onChange(selectedValue);
    }

    // 🔥 Para "Posições Detalhadas", busca pelo ID, não pela posição
    if (
      pageTitle === "Posições Detalhadas" &&
      props.options?.length > 0 &&
      props.id === "veiculosGroups"
    ) {
      // 👈 Busca por ID usando find
      const selectedVehicle = props.options.find(
        (v) =>
          v.vehicleId?.toString() === selectedValue?.toString() ||
          v.groupVehicleId?.toString() === selectedValue?.toString()
      );

      if (selectedVehicle) {
        dispatch({ type: "vehicleSelected", value: selectedVehicle });
        if (typeof props.handleOnlyPositionEvents === "function") {
          props.handleOnlyPositionEvents(false, selectedVehicle);
        }
        if (props.setUnderMaintenace) {
          props.setUnderMaintenace(selectedVehicle.underMaintenance);
        }
      }
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="filter" ref={dropdownRef}>
        <div>
          {props.hasIcon ? (
            <div className="icon-filter">
              <Icon size={20} />
            </div>
          ) : (
            ""
          )}
          <span className="title">{props.title}</span>
        </div>
        <div className="filter-select-container">
          {!isMulti ? (
            <div style={{ position: "relative" }}>
              <select
                className="filter-select"
                value={currentSelected[0] || ""}
                onChange={handleSelectChange}
                disabled={isLoading}
              >
                {isLoading ? (
                  <option value="">Carregando...</option>
                ) : (
                  optionsWithTodos.map((opt, index) => {
                    const value = getValue(opt);
                    const label = getLabel(opt);
                    return (
                      <option key={index} value={value}>
                        {label}
                      </option>
                    );
                  })
                )}
              </select>
              {isLoading && (
                <div
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid #ccc",
                      borderTop: "2px solid #009E80",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className="filter-select multiselect"
              onClick={() => setIsOpen((o) => !o)}
              style={props.hasSubTitle ? { width: "100%" } : { width: "40px" }}
              role="button"
              aria-haspopup="listbox"
              aria-expanded={isOpen}
            >
              {summaryLabel()}
              {isOpen && (
                <div
                  className="filter-dropdown"
                  role="listbox"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  {optionsWithTodos.map((opt, index) => {
                    const value = getValue(opt);
                    const label = getLabel(opt);
                    const checked = currentSelected.includes(value);
                    return (
                      <label
                        key={index}
                        className="filter-option"
                        onClick={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() =>
                            toggleOption(props.id, value, props.isMulti)
                          }
                        />
                        <span style={{ 
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "block",
                          width: "100%"
                        }}>{label}</span>
                      </label>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
